import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

function ShareCell({ share }) {
  if (share == null) return "—";
  return (
    <div className="flex items-center justify-end gap-2">
      <div className="w-24 h-1.5 rounded-full bg-[#EBF1EF] overflow-hidden">
        <div className="h-full bg-[#156F5B]" style={{ width: `${share}%` }} />
      </div>
      <span className="text-xs text-[#6B7280] w-10 text-right">{share.toFixed(0)}%</span>
    </div>
  );
}

/** Demand, meter reading and share of portfolio demand for every metered site. */
export function SiteBreakdownTable({ summary }) {
  const sites = summary?.sites || [];
  const total = summary?.total_demand_kw || 0;
  return (
    <div className="mt-10">
      <h2 className="text-xl font-heading font-bold text-[#212121]">Site breakdown</h2>
      <div className="mt-4 k-card overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="border-[#E5E7EB] hover:bg-transparent bg-[#F9FAFB]">
              <TableHead className="k-sublabel">Site</TableHead>
              <TableHead className="k-sublabel text-right">Demand (kW)</TableHead>
              <TableHead className="k-sublabel text-right">Meter reading (kWh)</TableHead>
              <TableHead className="k-sublabel text-right">Share of demand</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody data-testid="energy-breakdown-table">
            {sites.map((s, i) => (
              <TableRow key={s.site_id} className="border-[#F0F2F1] hover:bg-[#F9FAFB]" data-testid={`energy-row-${i}`}>
                <TableCell className="text-sm font-medium text-[#212121]">{s.site_dis}</TableCell>
                <TableCell className="text-sm text-right font-semibold text-[#156F5B]">
                  {s.demand_kw != null ? s.demand_kw.toLocaleString() : "—"}
                </TableCell>
                <TableCell className="text-sm text-right text-[#4D4D4D]">
                  {s.energy_kwh != null ? s.energy_kwh.toLocaleString() : "—"}
                </TableCell>
                <TableCell className="text-right">
                  <ShareCell share={total > 0 && s.demand_kw != null ? (s.demand_kw / total) * 100 : null} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
